export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_complete_4.dd19fd95.jpg";